document.addEventListener('DOMContentLoaded', function () {
    const cards = document.querySelectorAll('.m-collection-card__inner');

    // Expanded color palette with 12 unique colors (orange and green tones)
    let colorPalette = [
        '#FF5722', // Orange
        '#FF9800', // Light Orange
        '#FFC107', // Yellow Orange
        '#F57C00', // Deep Orange
        '#EF6C00', // Amber Orange
        '#E65100', // Burnt Orange
        '#4CAF50', // Green
        '#8BC34A', // Light Green
        '#CDDC39', // Yellow-Green
        '#388E3C', // Dark Green
        '#689F38', // Olive Green
        '#33691E',  // Forest Green
        '#FF5722', // Orange
        '#FF9800', // Light Orange
        '#FFC107', // Yellow Orange
        '#F57C00', // Deep Orange
        '#EF6C00', // Amber Orange
        '#E65100', // Burnt Orange
        '#4CAF50', // Green
        '#8BC34A', // Light Green
        '#CDDC39', // Yellow-Green
        '#388E3C', // Dark Green
        '#689F38', // Olive Green
        '#33691E'  // Forest Green
    ];

    cards.forEach((card, index) => {
        // Check if colorPalette has available colors
        if (colorPalette.length === 0) {
            console.warn('No more colors available in the palette.');
            return;
        }

        // Pick a random index from the remaining colors
        const randomIndex = Math.floor(Math.random() * colorPalette.length);
        const randomColor = colorPalette[randomIndex];

        // Remove the selected color from the palette to prevent repetition
        colorPalette.splice(randomIndex, 1);

        // Apply the color bar
        card.style.position = 'relative'; // Ensure the parent has relative positioning
        card.insertAdjacentHTML('beforeend', `<div class="random-color-bar"></div>`);
        const colorBar = card.querySelector('.random-color-bar');
        colorBar.style.position = 'absolute';
        colorBar.style.bottom = '0';
        colorBar.style.left = '0';
        colorBar.style.width = '100%'; // Full width of the card
        colorBar.style.height = '5px'; // Adjust the height of the color bar
        colorBar.style.backgroundColor = randomColor;
        colorBar.style.zIndex = '1';
    });
});
